module.exports = __webpack_public_path__ + "static/media/new_pack_super_dog_EN_768x350.10721a49.png";